import { render, staticRenderFns } from "./OwnerCustomerTab.vue?vue&type=template&id=1a54d355&scoped=true&"
import script from "./OwnerCustomerTab.vue?vue&type=script&lang=js&"
export * from "./OwnerCustomerTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a54d355",
  null
  
)

export default component.exports